import { firebaseOperationsApp } from './firebase/firebase';
import firebase from 'firebase/app';
let messaging;
if (firebase.messaging.isSupported()) {
  messaging = firebaseOperationsApp.messaging();
}

// const publicKey = "BP-lyNT0oLUmdn3DT1xGU6KKv2gDDYx4CNOyBdtm27k51vLZEi_c-BxeSVH3FSwykNxlCoHC4IpykNy_eZEjOC8"; // UAT
const publicKey = "BJYStXs0F2WgcemTeGeyA-SwdrRCLOyhtm6koIsKgeNnZx_V7KPDlBBpE7TcsZ9QzeLLWJWzI8bISZv5PTbhPlE"; // UATLF
// const publicKey = 'BKyruz4v5DyHFSlZaJMF8DFxb12wr8kEy2r8FMDbwx3i37nxfn0ckJaxG45-iAIEqquBGKDlJa96v7UNgK_Ca8k'; // Production

export const getToken = async () => {
  let currentToken = '';

  try {
    currentToken = await messaging.getToken({ vapidKey: publicKey });
  } catch (error) {
    console.log('An error occurred while retrieving token. ', error);
  }
  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve, reject) => {
    if (messaging) {
      messaging.onMessage((payload) => {
        resolve(payload);
      });
    } else {
      reject(new Error("Push API's are not supported by browser."));
    }
  });
